import { getField, updateField } from 'vuex-map-fields';
import helpers from '../../mixins/helpers';
import apiAxios from '../../services/apiAxios';

const state = {
    /* Registro de bancos */
    bancosCuentas: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',
    incluirInactivos: false,

    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.bancosCuentas = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR'(state) {
        state.bancosCuentas = [];
    },
    'SET_BANCOS_CUENTAS'(state, bancosCuentas) {
        state.bancosCuentas = bancosCuentas.map(bancoCuenta => ({
            ...bancoCuenta,
            _rowVariant: bancoCuenta.readonly? 'read-only' : '',
        }));
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_SELECT_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_SELECT_LIST'(state, params) {
        state.list = params.list;
        state.selectList = params.selectList;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getBancosCuentas: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }
            if (state.incluirInactivos) {
                if (state.incluirInactivos == true || state.incluirInactivos == 'true') {
                    queryString += '&incluirInactivos= true';
                }
            }

            apiAxios.get('bancoscuentas' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_BANCOS_CUENTAS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
    delete ( {}, bancoCuentaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`bancoscuentas/${bancoCuentaId}/inactivar`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
        }, error => {
            reject(error);
        })            
    },
    getList: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SELECT_LIST');
            
            let queryString = '';
            if (params) {
                if (params.monedaId) {
                    queryString += '?monedaId=' + params.monedaId;
                }
            }

            apiAxios.get('bancoscuentas/list' + queryString)
                .then(res => {
                    let params = {
                        list: res.data,
                        selectList: res.data.map(bancoCuenta => bancoCuenta.nombre.trim())
                    }
                    commit('SET_SELECT_LIST', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
        }, error => {
            reject(error);
        })
    },

};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}